export const ARTICLES_LOAD_SUCCESS = 'articles/LOAD_SUCCESS';
export const ARTICLES_CREATE_SUCCESS = 'article/CREATE_SUCCESS';
export const ARTICLES_EDIT_SUCCESS = 'articles/EDIT_ARTICLE';
export const ARTICLES_DELETE_SUCCESS = 'articles/DELETE_ARTICLE';
export const SETTINGS_LOAD_SUCCESS = 'settings/LOAD_SETTINGS';
export const LINK_CREATE_SUCCESS = 'link/CREATE_SUCCESS';
export const LINK_EDIT_SUCCESS = 'link/EDIT_LINK';
export const LINK_DELETE_SUCCESS = 'link/DELETE_LINK';
export const SHORTCUT_CREATE_SUCCESS = 'shortcut/CREATE_SHORTCUT';
export const SHORTCUT_EDIT_SUCCESS = 'shortcut/EDIT_SHORTCUT';
export const SHORTCUT_DELETE_SUCCESS = 'shortcut/DELETE_SHORTCUT';
export const SET_BUSY = 'other/SET_BUSY';
export const UNSET_BUSY = 'other/UNSET_BUSY';
